
      <div class="big-container">
        <router-outlet></router-outlet>
      </div>
